import type * as Types from '../../types/graphql';

export type CampaignSelectFragment = Pick<Types.Campaign, 'id' | 'name' | 'status' | 'type'> & {
  group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'status' | 'type'>>;
};

export type CampaignTemplateSelectFragment = Pick<Types.Campaign, 'id' | 'name' | 'status' | 'type'> & {
  variants?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<Types.Variant, 'id' | 'isOrigin' | 'templateSuffix' | 'templateType' | 'themePageID'> & {
          template?: Types.Maybe<Pick<Types.VariantTemplate, 'id' | 'redirectURL'>>;
        }
      >
    >
  >;
  group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'status' | 'type'>>;
};

export type CampaignTemplateEdgeSelectFragment = Pick<Types.CampaignEdge, 'cursor'> & {
  node?: Types.Maybe<
    Pick<Types.Campaign, 'id' | 'name' | 'status' | 'type'> & {
      variants?: Types.Maybe<
        Array<
          Types.Maybe<
            Pick<Types.Variant, 'id' | 'isOrigin' | 'templateSuffix' | 'templateType' | 'themePageID'> & {
              template?: Types.Maybe<Pick<Types.VariantTemplate, 'id' | 'redirectURL'>>;
            }
          >
        >
      >;
      group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'status' | 'type'>>;
    }
  >;
};

export const CampaignSelectFragmentDoc = `
    fragment CampaignSelect on Campaign {
  id
  name
  status
  type
  group {
    id
    title
    status
    type
  }
}
    `;
export const CampaignTemplateSelectFragmentDoc = `
    fragment CampaignTemplateSelect on Campaign {
  ...CampaignSelect
  variants {
    ...VariantWithTemplateSelect
  }
}
    `;
export const CampaignTemplateEdgeSelectFragmentDoc = `
    fragment CampaignTemplateEdgeSelect on CampaignEdge {
  cursor
  node {
    ...CampaignTemplateSelect
  }
}
    `;
